import styled from 'styled-components';

export const SpotlightHeroStyles = styled.div`
  background-color: #F8F6F5;
  background-image: url(${props => props.background});
  background-position: center;

  .container {
    display: block;
    justify-content: space-between;
    padding-top: 25px;
    text-align: center;

    ${props => props.theme.media.md} {
      display: flex;
      text-align: left;
    }
  }

  h1 {
    color: #3F5261;
    display: block;
    font-family: Poppins;
    font-size: 40px;
    line-height: 54px;
    margin-top: 10px;
    margin-bottom: 15px;
    font-weight: bold;
    text-align: center;

    ${props => props.theme.media.md} {
      font-size: 50px;
      line-height: 54px;
      margin-top: 120px;
      margin-bottom: 25px;
      text-align: left;
    }
  }

  img {
    display: block;
    max-width: 613px
    width: 100%;
  }

  .copy {
    color: #464646;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 25px;

    ${props => props.theme.media.md} {
      font-size: 22px;
      line-height: 34px;
      max-width: 488px;
    }
  }
  
`;
